<template>
  <div
    v-if="userInfo"
    class="close-statement"
    :class="{
      'close-statement--android': $isAndroid,
    }"
  >
    <div class="close-statement__title">
      Заявление на выход из клуба Kaspi Red
    </div>
    <div class="close-statement__main">
      <div class="close-statement__main_block">
        Я, {{ userInfo.fio }},<br />ИИН {{ userInfo.iin }}, прошу АО «Kaspi
        Bank» расторгнуть Договор рассрочки и лимита на покупки №{{
          userInfo.bankId
        }}
        (далее - Договор), исключить меня из клуба Kaspi Red, закрыть Счет
        {{ userInfo.repaymentAccountNumber }}, заблокировать карту №{{
          userInfo.cardNumber
        }}.
      </div>

      <div class="close-statement__main_block">
        Понимаю, что Договор будет расторгнут после погашения задолженности
        полностью.
      </div>
      <div class="close-statement__main_block">
        Остаток собственных денег прошу перевести на банковский счёт согласно
        указанию, данному мной на <a href="https://kaspi.kz">Kaspi.kz</a>.
        <br />В случае отсутствия банковского счёта, прошу выдать через кассу
        Банка.
      </div>
    </div>
    <div class="close-statement__divider"></div>
    <div class="close-statement__date">
      <div class="close-statement__date_title">Дата:</div>
      <div class="close-statement__date_value">
        {{ formattedDate }}
      </div>
    </div>
    <div class="close-statement__divider"></div>
    <CommonButton class="close-statement__btn" @click="$emit('sign')">
      Подписать заявление
    </CommonButton>
  </div>
</template>

<script>
import dayjs from "dayjs";
import CommonButton from "@/components/shared/button/CommonButton";

export default {
  components: {
    CommonButton,
  },
  props: {
    userInfo: {
      type: [Object, null],
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return dayjs().locale("ru").format("DD MMMM YYYY г.");
    },
  },
};
</script>
